import type { SearchSelectOption } from '@app/ui';

type LegacyOption<ValueType extends string | number> = Record<
    string,
    unknown
> & {
    value: ValueType;
};

export const toSearchSelectOptions = <ValueType extends string | number>(
    options: LegacyOption<ValueType>[] = [],
    labelKey = 'label',
): SearchSelectOption<ValueType>[] =>
    options.map(option => ({
        ...option,
        name: String(option[labelKey]),
        value: option.value,
    }));

export const getSelectedValues = <ValueType extends string | number>(
    options: LegacyOption<ValueType>[] = [],
    selected: Record<string, boolean> = {},
): ValueType[] =>
    options
        .filter(option => selected[String(option.value)])
        .map(option => option.value);

export const toSelectedObject = (
    values: string | number | Array<string | number> | null = [],
): Record<string, boolean> =>
    Object.fromEntries(
        (Array.isArray(values) ? values : []).map(value => [value, true]),
    );
